export const getCurrentUser = (store) => store.user?.user;
